module.exports = __webpack_public_path__ + "static/media/Zero.6f8755d9.png";